import React, { Component }  from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import FlightScheduleSearch from "../../../components/FlightScheduleSearch/FlightScheduleSearch";
import store from "../../../store";
import {Helmet} from "react-helmet";

class FlightSchedules extends Component {
  render () {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Ship" ? row.sections.map((section) => {
                          return section.title === "Facilities" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <h1 className="two-three-rows__title">Cargo Flight Schedules</h1>
        <p className="two-three-rows__description">Provides lane specific cargo schedule options which are not available in the published Passenger flight schedule. Sortable search results include real time flight information, interline destinations, and estimated recovery times. </p>
        <p className="two-three-rows__description">For the passenger schedule, please visit <a href="https://www.southwest.com/" rel="noopener noreferrer" target="_blank">Southwest.com</a></p>
        <div className="iframe-box-wrapper ptn">
          <FlightScheduleSearch infoText="Schedules are only available 10 days in advance."/>
        </div>
      </div>
    )
  }
}

export default FlightSchedules;



// WEBPACK FOOTER //
// ./src/pages/ship/FlightSchedules/FlightSchedules.js